import { useCallback, useEffect } from 'react'
import thread from 'app/thread'

/**
 * The `useHorizontalScroll` hook is used to enable horizontal scrolling
 * at certain breakpoints
 *
 * @param {object} ref - the react ref
 * @param {number} breakpoint - the breakpoint at which to start scrolling horizontally
 * @param {boolean} isDisabled - whether pointer wheel scroll is disabled
 */
export default function useHorizontalScroll (ref, breakpoint = 0, isDisabled) {
  const onWheel = useCallback(
    e => {
      if (thread.onResize.width <= breakpoint) {
        ref.current.scrollBy({
          left: e.deltaY * 0.5
        })
      }
    },
    [breakpoint]
  )

  /**
   * Effect: On mount/unmount
   */
  useEffect(() => {
    if (!ref || isDisabled) {
      return
    }

    ref.current.addEventListener('wheel', onWheel, { passive: true })

    return () => {
      if (!ref.current) {
        // Defensive
        return
      }

      ref.current.removeEventListener('wheel', onWheel, { passive: true })
    }
  }, [isDisabled])
}
